import { InjectionToken } from '@angular/core';
import { SpotterEnvironment } from '@spotter/environments/environment.template';



export const SPOTTER_ENV = new InjectionToken<SpotterEnvironment>('SPOTTER_ENV');